import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { getAdvancesForDateUrl } from "../constants/urls";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { Advance, AdvanceActions } from "../../domain/advance";
import { DaccachErrorActions } from "@/business/shared/commons/DaccachError";

export const getAdvancesByDayService = {
    async execute(token: string, day: string): Promise<Advance[]> {
        const url = getEnvVariable
            .execute("VUE_APP_DACCACH_URL")
            .concat(getAdvancesForDateUrl)
            .replace("{day}", day);

        const headers = {
            "web-token": token,
            Accept: "application/json",
        };

        const response: RestResponse = await restClient().sendRequest(
            url,
            "GET",
            null,
            headers
        );

        if (!response.isSuccess) {
            const errorMessage =
                response.statusCode == 422
                    ? DaccachErrorActions().extractFormError(response.content)
                    : response.content;
            throw DaccachErrorActions().createError(errorMessage);
        }

        return AdvanceActions().deserialize(response.content);
    },
};